/* @flow */
import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';

export class TextArea extends React.Component {
  getSelectionRange() {
    return {
      selectionStart: this.textArea.selectionStart,
      selectionEnd: this.textArea.selectionEnd,
    };
  }

  render() {
    const {
      field,
      placeholder,
      children,
      rows,
      maxLength,
      qaTag,
      ariaLabelledBy,
      ariaDescribedBy,
      noFormGroup,
    } = this.props;

    const inputClasses = classNames({
      'form-group': !noFormGroup,
      'has-error': field.meta.invalid,
    });

    return (
      <div className={inputClasses}>
        <textarea
          ref={(c) => { this.textArea = c; }}
          className="form-control"
          placeholder={placeholder}
          rows={rows}
          maxLength={maxLength}
          id={field.input.name}
          value={field.input.value}
          onChange={field.input.onChange}
          aria-labelledby={ariaLabelledBy}
          aria-describedby={ariaDescribedBy}
          data-qa-item={qaTag}
        />
        { children }
      </div>
    );
  }
}

TextArea.propTypes = {
  field: PropTypes.object.isRequired,
  children: PropTypes.object,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  maxLength: PropTypes.number,
  ariaLabelledBy: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  qaTag: PropTypes.string,
  noFormGroup: PropTypes.bool,
};
